import { render, staticRenderFns } from "./Laborant.vue?vue&type=template&id=d56455d6&scoped=true&"
import script from "./Laborant.vue?vue&type=script&lang=ts&"
export * from "./Laborant.vue?vue&type=script&lang=ts&"
import style0 from "./Laborant.vue?vue&type=style&index=0&id=d56455d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56455d6",
  null
  
)

export default component.exports